import React from "react";

import Check from '../img/check.svg'
import Sad from '../img/sad.svg'
import Happy from '../img/happy.svg'
import Neutral from '../img/neutral.svg'
import './styles/status.css'

const Status = (props) => {
    const option = props.option;
    const error = props.error;

    let  statusRender;

    switch(option){
        case 'city_connected':
             statusRender = ( 
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', backgroundColor: 'white', width: '90%', borderRadius: '14px', color: 'black'}}>
                    <img src={Happy} alt='face' className="icon"/>
                    <p style={{fontSize: '1.8rem', textAlign: 'center'}}>Comune <span style={{color:'#2ecc71', fontWeight: 'bold'}}>connesso</span> alla rete Fibercop.</p>
                </div>)
                break;
        case 'civic_connected_of':
             statusRender = 
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <img src={Check} alt='face' className="icon"/>
                    <p style={{fontSize: '1.8rem'}}><span style={{color:'#FF0F64', fontWeight: 'bold'}}>Connesso</span> alla rete OpenFiber.</p>
                </div>
                break;
        case 'civic_not_connected_fc':
             statusRender = 
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <img src={Sad} alt='face' className="icon"/>
                    <p style={{fontSize: '1.8rem', textAlign: 'center'}}>Oh no...<span style={{color:'#D2042D', fontWeight: 'bold'}}>non sei connesso</span><span style={{color:'#FF0F64'}}></span> alla rete Fibercop.</p>
                </div>
                break;
        case 'civic_not_connected_of':
             statusRender =
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                    <img src={Sad} alt='face' className="icon"/>
                    <p style={{fontSize: '1.8rem', textAlign: 'center'}}>Oh no...<span style={{color:'#D2042D', fontWeight: 'bold'}}>non sei connesso</span><span style={{color:'#FF0F64'}}></span> alla rete OpenFiber.</p>
                </div>
                break;
        case 'city_not_connected_of':
             statusRender =
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                <img src={Sad} alt='face' className="icon"/>
                <p style={{fontSize: '1.7rem', textAlign: 'center'}}>Oh no... comune <span style={{color:'#D2042D', fontWeight: 'bold'}}>non connesso</span><span style={{color:'#FF0F64'}}></span> alla rete OpenFiber.</p>
            </div>
            break;
        case 'city_connected_of':
             statusRender =
            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
                <img src={Check} alt='face' className="icon"/>
                <p style={{fontSize: '1.9rem', textAlign: 'center'}}>Comune <span style={{color:'#FF0F64', fontWeight: 'bold'}}>connesso</span> alla rete OpenFiber.</p>
            </div>
            break;
        case 'something_missing':
             statusRender =
            <div style={{margin: 'auto', marginTop: '30px', textAlign: 'center', paddingBottom: '30px'}}>
                <img src={Neutral} alt='face' className="icon"/>
                <p style={{fontSize: '1.5rem', textAlign: 'center'}}>Sembrerebbe ci siano dei <span style={{color:'#F1C40F'}}>problemi</span>.</p>
                <p style={{fontSize: '1.3rem', color: '#5f6a6a', width: '96%', margin: 'auto', fontWeight: 'bold'}}>Stato: <span style={{color: '#F1C40F', whiteSpace: 'nowrap'}}>{error.num}</span></p>
                <p style={{fontSize: '1.3rem', color: '#5f6a6a', width: '96%', margin: 'auto'}}>{error.text}</p>
            </div>
            break;
        case 'pac/pal':
             statusRender =
            <div style={{margin: 'auto', marginTop: '30px', textAlign: 'center', paddingBottom: '30px'}}>
                <img src={Happy} alt='face' className="icon"/>
                <p style={{fontSize: '2rem', textAlign: 'center'}}>Sei <span style={{color:'#2ECC71'}}>Connesso</span>, non è fantastico?</p>
                <p className="detalis" style={{ color: '#5f6a6a', margin: 'auto', width: '95%'}}><span style={{color: '#ff0f64'}}>ATTENZIONE</span>: L’indirizzo risulta coperto ma, essendo un civico censito come “pubblica amministrazione” è identificato come <span style={{color: '#ff0f64'}}>PAC/PAL</span>, in questo indirizzo sono vendibili solo FTTH dedicate punto/punto.</p>
            </div>
            break;
        default: 
            return null;
    }

    return (
        <>
            {statusRender}
        </>
    )
}

export default Status;